
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class RecruitHeader extends Vue {
  @Prop({ default: "格力校园招聘" })
  title?: string;
}
